<template>
  <v-dialog style="width:100%;" v-model="dialog" class="fill-height" transition="dialog-transition">
    <div
        slot="activator"
        class="ff-fix"
    >
      <v-avatar
          size="70px"
          color="#009FDF"
          :class="'pa-0 elevation-8 '+animationState"
      >
        <v-img :src="productImageSource" alt=""></v-img>
      </v-avatar>
    </div>
    <v-card color="#CCD5ED">
      <v-toolbar dark color="#002EA7">
        <v-toolbar-title>{{ productLabel }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon dark @click="dialog = false">
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text class="text-xs-center">
        <!-- zentriertes Icon -->
        <v-avatar
            size="85px"
            color="#009FDF"
            class="pa-0 mt-2 mb-3 elevation-8 align-center"
        >
          <v-img :src="productImageSource" alt=""></v-img>
        </v-avatar>
        <!-- linksbündiger Text -->
        <div class="text-xs-left mb-4">
          <div class="mb-3">
            Über diese Kategorie können folgende einzelne Gegenstände abgesichert werden. Zubehör ist nicht automatisch
            mit abgesichert.
          </div>
          <div class="font-weight-bold">
            {{ productDescription }}
          </div>
          <!-- Ergänzung für "Sportgeräte" -->
          <div v-if="productIndex==12">
            <div class="mt-2 mb-2">
              <a href='https://www.oeffentliche.de/content/produkte/haus-wohnen/hausrat/' target='_blank'>Über 4gewinnt
                können <strong>keine Fahrräder</strong> abgesichert werden!!!</a>
            </div>
          </div>

          <!-- Ergänzung für "Sonstiges" -->
          <div v-if="productIndex==16">
            <div class="mt-2 mb-2">
              Ist der gewünschte Gegenstand nicht dabei?<br>-> <a href='mailto:4gewinnt@oeffentliche.de'>4gewinnt@oeffentliche.de</a>
            </div>
            <div>
              Diese Gegenstände können <strong>nicht</strong> abgesichert werden: Lebewesen, Gegenstände, die sich nicht
              rechtmäßig in Besitz des Versicherungsnehmers befinden und Sachen, Fahrräder, Drohnen über 5 kg,
              Motorbetriebene Fahrzeuge zum Personen- und Gütertransport, Sparbücher, Wertpapiere, Bargeld.
            </div>
          </div>

        </div>
        <!-- Button -->
        <v-btn block
               color="primary"
               class="mb-3"
               :disabled="cartIsFull"
               @click="selectProduct"
        >
          <v-icon>add</v-icon>
          Hinzufügen
        </v-btn>
      </v-card-text>

    </v-card>
  </v-dialog>
</template>

<script>
import {mapGetters} from 'vuex';
import { postGaMessage } from "@/stores/modules/ga";

/*
Zur Unterscheidung des Produktes nach Index:
- this.productIndex
  - ist eine prop, wird also vom Parent übergeben
  - Inhalt =
*/

export default {
  name: 'ProductIntro',
  data() {
    return {
      dialog: false
    }
  },
  props: {
    productIndex: {
      default: 0
    },
    animationState: {
      default: ""
    }
  },
  watch: {
    dialog(){
      if(this.dialog){
        postGaMessage('elementClicked', this.productLabel);
      }
    }
  },
  computed: {
    productImageSource() {
      return 'images/icons/svg/weiss/' + this.productIndex + '.svg';
    },
    productLabel() {
      return this.product(this.productIndex).label;
    },
    productDescription() {
      return this.product(this.productIndex).assortmentDescription;
    },
    cartIsFull() {
      return (this.$store.state.work.forxchange.offerRequest.contract.products.length >= 4);
    },
    ...mapGetters('work', {
      product: 'getProduct'
    })
  },
  methods: {
    selectProduct() {
      postGaMessage('elementClicked', this.productLabel + ' hinzufügen');
      if (this.$store.state.work.forxchange.offerRequest.contract.products.length < 4) {
        this.$store.dispatch('work/selectProduct', this.productIndex);
        this.dialog = false;
        this.$emit('product-selected', (this.$store.state.work.forxchange.offerRequest.contract.products.length - 1));
      }
      return;
    }
  },
  components: {}
}
</script>

<style scoped>
/* Vorläufige Hervorhebung für Animationstest */
.blink {
  border: 3px solid yellow;
  border-radius: 50%;
}

div.fontsize-smaller {
  font-size: smaller;
}


/* Firefox fix */
.ff-fix div.v-responsive.v-image {
  width: 70px !important;
  height: 70px !important;
}

</style>
